<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 0c.4 0 .7.1.9.4.3.3.4.6.4.9v18.1l7.1-7.1c.3-.2.6-.4.9-.4.3 0 .7.1.9.4.2.2.4.6.4.9 0 .3-.1.7-.4.9L13 23.6c-.3.3-.6.4-1 .4s-.7-.1-.9-.4l-9.3-9.3c-.1-.1-.2-.3-.3-.4-.1-.2-.1-.3-.1-.5s0-.4.1-.5c.1-.2.2-.3.3-.4s.3-.2.4-.3c.1-.2.3-.2.5-.2s.4 0 .5.1c.2.1.3.2.4.3l7.1 7.1V1.3c0-.4.1-.7.4-.9.2-.3.6-.4.9-.4z"
    />
  </svg>
</template>
